import { useEffect } from "react"
import { garconClient } from "@apis/axiosClients"
import { useAuth0 } from "@auth0/auth0-react"

// We need to check if the error is a string because we have things like this with a 401 code:
// {
//   "type": "BadLogin",
//   "error": "Error: Status code 429 with message {\"error\"=>\"access_denied\", \"error_description\"=>\"Too Many Requests\", \"error_uri\"=>\"https://auth0.com/docs/policies/rate-limits\"}"
// }
// So since that's an object, doing .toLowerCase will throw the error error.response?.data?.toLowerCase is not a function.

export const useUnauthorizedInterceptor = () => {
  const { logout } = useAuth0()

  useEffect(() => {
    const resInterceptor = garconClient.interceptors.response.use(
      function onFulfilled(response) {
        return response
      },
      function onRejected(error) {
        if (
          import.meta.env.VITE_DISABLE_UNAUTHED_LOGOUT !== "true" &&
          error.response?.status === 401 &&
          // We need to check if the error is a string. See comment above for more details.
          typeof error.response?.data === "string" &&
          error.response?.data?.toLowerCase() === "signature has expired"
        ) {
          // Save current location to use it later in onRedirectCallback
          const logOutUrl = window.location.pathname + window.location.search
          localStorage.setItem("logOutUrl", logOutUrl)
          logout({ logoutParams: { returnTo: window.location.origin } })
          return Promise.reject(
            "Your session has expired. Redirecting to login...",
          )
        }

        // Every other rejection is left for useApiErrorInterceptor to format.
        return Promise.reject(error)
      },
    )

    return () => {
      garconClient.interceptors.response.eject(resInterceptor)
    }
  }, [logout])
}
